<template>
  <div id="topBar">
    <div class="row">
      <DynamicComponents :components="components" />
      <div class="topbar-parts">
        <MusubiPartSwitcher :active="activePart" />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * TheTopMenuBar (icarus-theme-base override) — keeps the vendor topbar's
 * server-driven content (logo + title tile + breadcrumbs) and appends the
 * global MusubiPartSwitcher (Acquire / Outreach / Analytics), right-aligned.
 *
 * This completes the "both" nav model: the switcher hops between the three
 * platform parts from the persistent topbar (visible on every page), while
 * the LHS sidebar carries the within-part submenus. The active chip is
 * derived from the current route's top-level segment; non-part routes
 * (/admin/*, /) leave no chip active.
 *
 * Overrides @apexl/icarus-core's TheTopMenuBar via the build-time theme tier
 * (themes/base/structure auto-registered with theme > project > core
 * precedence in index.js). MusubiPartSwitcher is auto-registered from
 * components/ui by basename.
 */
import DynamicComponents from "@apexl/icarus-core/src/components/partials/DynamicComponents.vue";

export default {
  name: 'TheTopMenuBar',
  components: { DynamicComponents },
  props: {
    components: { type: Array, default: () => [] },
  },
  computed: {
    activePart() {
      const p = this.$route?.path || '';
      if (p.startsWith('/outreach')) return 'outreach';
      if (p.startsWith('/analytics')) return 'analytics';
      if (p.startsWith('/acquire')) return 'acquire';
      return ''; // /admin/*, / — no part highlighted
    },
  },
};
</script>

<style lang="scss">
// The vendor topbar's inner `.row` is a Bootstrap 5 row, whose `> *` rule
// forces `width: 100%` on EVERY direct child — so the title tile and the
// switcher each claim the full width and overlap/stack. Cancel that width,
// keep a single non-wrapping row, let the title flex and pin the switcher
// hard-right via margin-left:auto.
#topBar > .row {
  flex-wrap: nowrap;
  align-items: center;
}
#topBar > .row > * {
  width: auto;
  max-width: none;
}
#topBar > .row > :first-child {
  flex: 1 1 auto;
  min-width: 0;
}
#topBar .topbar-parts {
  margin-left: auto;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  padding-left: 1rem;
}
</style>
